module.exports = __webpack_public_path__ + "img/04-3-2运维安全.0fc89385.svg";